import React from "react";
import { ButtonComponent } from "@/components";
import { useNavigate } from "react-router-dom";
import { RoutesPathList } from "@/config/routes/Routes.tsx";
import { isSNS } from "@/utils/utils";
import bgSNS from "../assets/SVG/bgSNS.svg";

const ExchangeNotApproved: React.FC = () => {
  const navigate = useNavigate();

  return !isSNS() ? (
    <div className="flex items-center flex-col justify-between h-screen p-12">
      <div className="flex justify-center h-full flex-col items-center gap-10">
        <svg
          width="99"
          height="89"
          viewBox="0 0 99 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3548_11306)">
            <path
              d="M49.1409 0.0231754C52.7709 -0.326114 56.3322 3.26126 58.0285 6.16437L97.6068 74.7739C100.442 80.394 99.0428 86.518 92.4779 88.0727C89.6517 88.7426 86.5766 88.3217 83.6703 88.4219C61.1608 89.1864 37.264 89.2093 14.7545 88.4191C10.8613 88.2817 6.48468 89.0862 3.17505 86.5524C-0.64948 83.6235 -0.632317 79.286 1.19842 75.1604L41.2429 5.58317C43.2253 2.90052 45.6024 0.363875 49.1409 0.0231754ZM53.2171 57.507C53.0169 56.6137 53.3916 55.8321 53.4889 55.0591C53.7978 52.6055 54.0123 50.1061 54.3785 47.6467C55.1022 42.771 56.5267 37.2339 56.9215 32.4412C57.2447 28.516 55.8088 24.2129 51.5838 23.2137C45.7054 21.8251 41.5576 26.3945 42.0782 32.152C42.6532 38.5137 44.5869 45.7314 45.4823 52.2247C45.7225 53.9712 45.6796 55.7777 46.083 57.4955L53.2228 57.5099L53.2171 57.507ZM56.9558 69.2626C56.9558 65.1456 53.6205 61.8073 49.507 61.8073C45.3936 61.8073 42.0582 65.1456 42.0582 69.2626C42.0582 73.3796 45.3936 76.7179 49.507 76.7179C53.6205 76.7179 56.9558 73.3796 56.9558 69.2626Z"
              fill="#FF0000"
            />
          </g>
          <defs>
            <clipPath id="clip0_3548_11306">
              <rect width="99" height="89" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div className="text-center">
          <h1 className="text-3xl text-red-500 font-bold mb-4">
            Transaction was not approved
          </h1>
        </div>
      </div>

      <ButtonComponent
        title={"Retry"}
        actionCallback={() => navigate(RoutesPathList.ExchangePhone)}
        name={`button--classic w-[10.5rem] text-center`}
      />

      <ButtonComponent
        title={"Exit"}
        actionCallback={() => navigate(RoutesPathList.NewClientPOS)}
        name={`button--classic w-[10.5rem] mt-5 text-center !bg-[#222b45] !text-white`}
      />
    </div>
  ) : (
    <div
      className="overflow-hidden pt-[5rem] min-h-screen bg-[#1C1C1C] pb-[6rem] flex flex-col items-center"
      style={{
        backgroundImage: `url(${bgSNS})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex justify-center h-full flex-col items-center gap-10">
        <svg
          width="99"
          height="89"
          viewBox="0 0 99 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3548_11306)">
            <path
              d="M49.1409 0.0231754C52.7709 -0.326114 56.3322 3.26126 58.0285 6.16437L97.6068 74.7739C100.442 80.394 99.0428 86.518 92.4779 88.0727C89.6517 88.7426 86.5766 88.3217 83.6703 88.4219C61.1608 89.1864 37.264 89.2093 14.7545 88.4191C10.8613 88.2817 6.48468 89.0862 3.17505 86.5524C-0.64948 83.6235 -0.632317 79.286 1.19842 75.1604L41.2429 5.58317C43.2253 2.90052 45.6024 0.363875 49.1409 0.0231754ZM53.2171 57.507C53.0169 56.6137 53.3916 55.8321 53.4889 55.0591C53.7978 52.6055 54.0123 50.1061 54.3785 47.6467C55.1022 42.771 56.5267 37.2339 56.9215 32.4412C57.2447 28.516 55.8088 24.2129 51.5838 23.2137C45.7054 21.8251 41.5576 26.3945 42.0782 32.152C42.6532 38.5137 44.5869 45.7314 45.4823 52.2247C45.7225 53.9712 45.6796 55.7777 46.083 57.4955L53.2228 57.5099L53.2171 57.507ZM56.9558 69.2626C56.9558 65.1456 53.6205 61.8073 49.507 61.8073C45.3936 61.8073 42.0582 65.1456 42.0582 69.2626C42.0582 73.3796 45.3936 76.7179 49.507 76.7179C53.6205 76.7179 56.9558 73.3796 56.9558 69.2626Z"
              fill="#FF0000"
            />
          </g>
          <defs>
            <clipPath id="clip0_3548_11306">
              <rect width="99" height="89" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div className="text-center">
          <h1 className="text-[1.6875rem] text-[#F00] font-[700] font-[helvetica] mb-4">
            Transaction was <br/> not approved
          </h1>
        </div>
      </div>

      <ButtonComponent
        title={"Retry"}
        actionCallback={() => navigate(RoutesPathList.ExchangePhone)}
        name={`text-[#8AFEFD] mt-[12rem] font-[600] text-[1.1875rem] w-[10.5rem] text-center`}
      />

      <ButtonComponent
        title={"Exit"}
        actionCallback={() => navigate(RoutesPathList.NewClientPOS)}
        name={`button__green w-[19.4375rem] h-[3.625rem] mt-5 text-center text-[1.2rem] !text-black font-[500]`}
      />
    </div>
  );
};

export default ExchangeNotApproved;
